// extracted by mini-css-extract-plugin
export default {"loader":"Loading_loader__Lfros","spinner":"Loading_spinner__xorDa","spin":"Loading_spin__AVITX"};